import React from 'react';
import CloseIcon from '@mui/icons-material/Close'; // Icono de cierre de Material UI
import fingerAnimated from '../../../../../assets/icon/finger-animated-unscreen.gif';
import cancel from '../../../../../assets/images/ic-cancel.svg';
const FingerPrintSpinner = ({ capturing, onClose, className='background-general-950-opacity05' }) => {
    if (!capturing) return null;
    return (
        <div className={`loader_container ${className}`} id='overlay'>
            {' '}
            <div className='loader_div'>
                {' '}
                <img className='modalClose' onClick={onClose} src={cancel} alt='' />
                <img src={fingerAnimated} alt='Fingerprint Animation' width='300px' height='300px' />
            </div>
        </div>
    );
};
export default FingerPrintSpinner;
